import { WidgetPageGlasgowState } from './widgetPageGlasgow.initialState';

type WidgetPageAction = { type: string };

export const widgetPageReducer = (state: WidgetPageGlasgowState = {} as WidgetPageGlasgowState, action: WidgetPageAction) => {
  switch (action.type) {
    default:
      return state;
  }
};
